import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { State } from "../../redux/reducers/root";
import SupportItem from "../shared/support-item";
import WalletInfo from "./wallet-info";
import { fetchWallet } from "../../redux/actions/wallet";
import Loading from "../shared/loading";

const Wallet = () => {
  document.title = "کیف پول - پنل دستیار پزشک خوب";

  const Items = [
    {
      title: "پشتیبانی تلفنی",
      description: "09212154772",
      icon: "far fa-phone fa-lg",
      link: "tel:09212154772",
      color: "primary",
    },
  ];
  const dispatch = useDispatch();

  const doctor = useSelector((state: State) => state.selectDoctor);
  const fetchData = async () => {
    doctor?.id && (await dispatch(fetchWallet(doctor.id)));
  };

  useEffect(() => {
    fetchData();
  }, [doctor.id]);

  const walletStatus = useSelector((state: State) => state.wallet.status);
  const walletData = useSelector((state: State) => state.wallet).data;
  const { balance } = walletData;

  if (walletStatus === "LOADING") return <Loading />;

  return (
    <div className="container my-4">
      <WalletInfo balance={balance!} />
      <div className="px-3 mt-8 text-sm bg-white rounded-md shadow">
        <p className="py-4 font-bold">کیف پول پزشک خوب</p>
        <p className="pb-3 leading-8 text-justify">
          مبلغ نمایش داده شده در کیف پول، مجموع درآمد شما از خدمات مختلف است که پس از کسر سهم پزشک خوب محاسبه شده است.
          با استفاده شما از خدماتی مانند مشاوره تصویری، مبالغ پرداختی کاربر پس از کسر سهم پزشک خوب، به کیف پول شما واریز
          می‌شود. <br />
          برای فعال‌سازی و استفاده از خدمات مشاوره تصویری، تسویه موجودی کیف پول یا استفاده از آن برای خدمات افزایش
          بازدید، معرفی در صفحه اول، معرفی در وبلاگ و غیره، با پشتیبانی در ارتباط باشید.
        </p>
      </div>
      <div>
        <p className="mt-4 mb-2 text-base font-bold text-pkc-greyish-brown">تماس با پشتیبانی </p>
        <SupportItem description_ltr className="mt-2 shadow" {...Items[0]} />
      </div>
    </div>
  );
};

export default Wallet;
